module.exports = __webpack_public_path__ + "img/p1-info@2x.df1c7d0b.jpg";